import { createFileRoute, getRouteApi } from "@tanstack/react-router"

import { TeamSectionPage } from "@/app/components/team-section-page"

const shellRoute = getRouteApi("/_app-shell")

export const Route = createFileRoute("/_app-shell/team/$orgId/vehicles/$vehicleId")({
  head: () => ({ meta: [{ title: "Vehicle - Kestly" }] }),
  component: function TeamVehicleRoute() {
    const { teams } = shellRoute.useLoaderData()
    const { orgId, vehicleId } = Route.useParams()
    return <TeamSectionPage teams={teams} orgId={orgId} section="vehicles" vehicleId={vehicleId} />
  },
})
